import { API_COMPOSER_SERVICE } from '@eggplant/api-hosts'
import { DataRequest } from '@eggplant/data-request'
import type { KeycloakEnabledResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: (config: KeycloakEnabledResponse) => ReactElement
}

const GetKeycloakConfigRequest = ({
  children
}: Props) => {
  const url = `${API_COMPOSER_SERVICE}/services/iam/v1.0.0`

  return (
    <DataRequest
      children={children}
      method='get'
      url={url}
    />
  )
}

export default GetKeycloakConfigRequest
